/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {sendToExtensionById, sendToExtension} from './ExtensionCommunicate';
import Token from '../../../packages/extension/src/background/Token';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {getLocale} from './../locales';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'SignIn.title', 'defaultMessage': 'Access granted'}
});


export function sendToken(extensionId) {
    let token = Token.get();

    if (!Token.isExpired()) {
        let msg = {
            message: 'dativery-set-token',
            data: {
                token: token,
                locale: getLocale()
            }
        };


        if (extensionId) {
			return new Promise((resolve, reject) => {
				try {
					sendToExtensionById(extensionId, msg, () => {
						resolve();
					});
				} catch (e) {
					reject(e);
				}
			});
        } else {
            return sendToExtension(msg);
        }
    }

    return Promise.resolve();
}

interface SignInProps {
    extensionId: string;
    intl: IntlShape;
    relay?: object;
    user: User;
}

class SignIn extends React.Component<SignInProps> {

    static propTypes = {
        extensionId: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired,
    };

    typeName = 'channels';

    static contextTypes = {
        router: PropTypes.object,
    };

    constructor() {
        super();
    }

    componentDidMount() {
        sendToken(this.props.extensionId).then(() => {
            window.location = "/";
        }).catch((e) => {
            console.error(e); // eslint-disable-line no-console
        });
    }

    render() {
        return (
            <AppPanel title={this.props.intl.formatMessage(messages.title)}>
                <center><div className="fa fa-4x fa-spin fa-refresh"/></center>
            </AppPanel>
        );
    }
}


export default Relay.createContainer(injectIntl(SignIn), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id
            }
        `,
    },
});
